import { z } from 'zod'

/**
 * Personal access tokens let a tool outside hugo act as the user, today Claude Code over MCP
 * (`/api/mcp`). The secret (`hugo_pat_…`) is shown once when it is made; hugo keeps only its
 * hash and the first characters (`prefix`) so the user can tell tokens apart. Revoking one stops
 * it at once.
 */
export const ACCESS_TOKEN_PREFIX = 'hugo_pat_'
export const ACCESS_TOKEN_NAME_MAX = 60
/** At most this many tokens that are not revoked. */
export const ACCESS_TOKENS_MAX = 20

export const accessTokenNameSchema = z
  .string()
  .trim()
  .min(1, 'name is required')
  .max(ACCESS_TOKEN_NAME_MAX)

export const accessTokenSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  /** The start of the secret, e.g. `hugo_pat_k3Xa`: enough to recognize it, not to use it. */
  prefix: z.string(),
  createdAt: z.iso.datetime(),
  lastUsedAt: z.iso.datetime().nullable(),
})
export type AccessToken = z.output<typeof accessTokenSchema>

/** Whether a string looks like one of hugo's tokens (before looking it up). */
export const isAccessTokenSecret = (value: string): boolean =>
  value.startsWith(ACCESS_TOKEN_PREFIX) &&
  value.length >= ACCESS_TOKEN_PREFIX.length + 32 &&
  value.length <= 200
